import { parseAsPageNumber } from '@shared/utils';
import { parseAsStringLiteral, useQueryStates } from 'nuqs';

export const QSET_QUESTION_LIST_OPTIONS = ['1', '10', '50', '100', 'All'] as const;
export type QSetQuestionListOption = (typeof QSET_QUESTION_LIST_OPTIONS)[number];

export function useQSetQuestionListSearchParams() {
  const [{ page, pageSize }, setExamCourseSearchParams] = useQueryStates({
    page: parseAsPageNumber.withDefault(0),
    pageSize: parseAsStringLiteral(QSET_QUESTION_LIST_OPTIONS).withDefault('1'),
  });

  const nextPage = () => {
    setExamCourseSearchParams({
      page: page + 1,
    });
  };

  const previousPage = () => {
    setExamCourseSearchParams({
      page: page - 1,
    });
  };

  const goToPage = (page: number) => {
    setExamCourseSearchParams({
      page: page,
    });
  };

  const changePageSize = (pageSize: QSetQuestionListOption) => {
    setExamCourseSearchParams({
      page: 0,
      pageSize,
    });
  };

  const getPageSizeAsNumber = (pageSize: QSetQuestionListOption) => {
    return !isNaN(parseInt(pageSize)) ? parseInt(pageSize) : 10;
  };

  return [
    {
      page,
      pageSize,
    },
    {
      changePageSize,
      nextPage,
      previousPage,
      goToPage,
      getPageSizeAsNumber,
    },
  ] as const;
}
